import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, message } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { changeAdminPassword } from "../../services/authService";
import { useAuth } from "../../contexts/AuthContext";
import toast from "react-hot-toast";

const { Title } = Typography;

const AdminChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const payload = {
        adminId: user._id,
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      };

      await changeAdminPassword(payload);
      toast.success("Password changed successfully!");
      setLoading(false);
    } catch (error) {
      message.error(error.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-[#f8fafc] p-4">
      <Card
        className="w-full max-w-md rounded-2xl shadow-md border border-gray-100"
        bordered={false}
      >
        <div className="text-center mb-6">
          <LockOutlined className="text-4xl text-[#1c5a85]" />
          <Title level={4} className="!text-[#1c5a85] mt-2">
            Change Password
          </Title>
        </div>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="oldPassword"
            label="Current Password"
            rules={[
              { required: true, message: "Please enter your current password" },
            ]}
          >
            <Input.Password placeholder="Enter current password" />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[
              { required: true, message: "Please enter your new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirm New Password"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            className="bg-[#1c5a85] mt-2"
          >
            Update Password
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default AdminChangePassword;
